/**
 * smartAddEventListener
 *
 * Some convenience for event listener adding.
 *
 * - Allows to add the listener to multiple events at once:
 *   smartAddEventListener(window, 'click mousemove', () => {console.log('hallo');});
 *
 * @param object
 * @param events
 * @param listener
 */
export function smartAddEventListener (object, events, listener, options) {
  events.split(' ').forEach((event) => {
    object.addEventListener(event, listener, options);
  })
};



// WEBPACK FOOTER //
// ./website/vendor/scripts/fabrique/helpers/eventlisteners.js